import { tns } from 'tiny-slider/src/tiny-slider';

function initialize() {
  const carouselElements = document.querySelectorAll('[data-banner-gallery]');
  carouselElements.forEach((carouselElement) => {
    const timerInterval =
      carouselElement.getAttribute('data-banner-interval') || 5000;

    let slider = null;
    let timerHandle = null;

    const stopAutoPlay = () => {
      if (timerHandle) {
        clearInterval(timerHandle);
        timerHandle = null;
      }
    };

    const startAutoPlay = () => {
      stopAutoPlay();
      timerHandle = setInterval(() => {
        slider?.goTo('next');
      }, timerInterval);
    };

    slider = tns({
      container: carouselElement,
      mode: 'gallery',
      controls: false,
      navPosition: 'bottom',
      mouseDrag: true,
      onInit: (instance) => {
        startAutoPlay();
        Array.from(instance.navItems).forEach((btn) => {
          btn.addEventListener('click', () => {
            stopAutoPlay();
          });
        });
      },
    });

    slider.events.on('touchStart', () => {
      stopAutoPlay();
    });
    slider.events.on('dragStart', () => {
      stopAutoPlay();
    });
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        startAutoPlay();
      } else {
        stopAutoPlay();
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', initialize);
